import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type ResendFamilyEventSmsPath =
  operations['AdminEventController_sendLmsEachResend']['parameters']['path'];
type ResendFamilyEventSmsHeaders =
  operations['AdminEventController_sendLmsEachResend']['parameters']['header'];
type ResendFamilyEventSmsData = components['schemas']['AdminResendMemberPhoneNumber'];

interface ResendFamilyEventSmsProps {
  path: ResendFamilyEventSmsPath;
  data: ResendFamilyEventSmsData;
  headers?: OmitGroupIdInHeader<ResendFamilyEventSmsHeaders>;
}

type ResendFamilyEventSmsResponse = unknown;

export async function resendFamilyEventSms({
  path,
  data,
  headers,
}: ResendFamilyEventSmsProps): Promise<ResendFamilyEventSmsResponse | false> {
  const response = await authenticateRequest<ResendFamilyEventSmsResponse>({
    method: 'post',
    url: `/api/v1/admin/events/${path.eventId}/sms-resend`,
    headers,
    data,
  });

  console.log('resendFamilyEventSms', { response });
  return response;
}
